import Image from 'next/image';
import { VariantCardBox } from './styled';

export default function VariantCard(props) {
  const { data, index, id, variantClickHandler, productId } = props;
  return (
    <VariantCardBox
      highlight={productId == data?.id}
      onClick={() => variantClickHandler(data?.id)}
      key={`variantCard${index}`}
      id={id}
    >
      <Image
        src={data?.image}
        alt={data?.name}
        quality={90}
        width={86}
        height={86}
        sizes="80vw"
      />
      <h6>{data?.variantType}</h6>
    </VariantCardBox>
  );
}
